/** Column definition for configuration */
export interface ColumnConfig {
  field: string;
  headerName: string;
  visible: boolean;
  width?: number;
}

/** Default column set matching GWT StudyListPanel defaults */
export const DEFAULT_COLUMNS: ColumnConfig[] = [
  { field: 'name', headerName: 'Patient Name', visible: true },
  { field: 'id', headerName: 'Patient ID', visible: true },
  { field: 'sex', headerName: 'Sex', visible: true },
  { field: 'dob', headerName: 'DOB', visible: true },
  { field: 'acc', headerName: 'Accession #', visible: true },
  { field: 'date', headerName: 'Study Date', visible: true },
  { field: 'mod', headerName: 'Modality', visible: true },
  { field: 'descr', headerName: 'Description', visible: true },
  { field: 'bod', headerName: 'Body Part', visible: true },
  { field: 'status', headerName: 'Status', visible: true },
  { field: 'physician', headerName: 'Ref. Physician', visible: true },
  { field: 'radiologist', headerName: 'Radiologist', visible: true },
  { field: 'ae', headerName: 'AE Title', visible: true },
  { field: 'dicomCount', headerName: '#', visible: true },
  { field: 'siteName', headerName: 'Site', visible: true },
  { field: 'comment', headerName: 'Comment', visible: false },
  { field: 'history', headerName: 'History', visible: false },
  { field: 'reason', headerName: 'Reason for Exam', visible: false },
  { field: 'finalRead', headerName: 'Final Read', visible: false },
  { field: 'faxCount', headerName: 'Fax Count', visible: false },
];

const STORAGE_KEY = 'brit_columns';

/** Load saved column config from localStorage or use defaults */
export function loadColumnConfig(): ColumnConfig[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const saved = JSON.parse(raw) as ColumnConfig[];
      const savedMap = new Map(saved.map((c) => [c.field, c]));
      const merged: ColumnConfig[] = [];
      for (const col of saved) {
        const def = DEFAULT_COLUMNS.find((d) => d.field === col.field);
        if (def) merged.push({ ...def, visible: col.visible });
      }
      for (const def of DEFAULT_COLUMNS) {
        if (!savedMap.has(def.field)) merged.push(def);
      }
      return merged;
    }
  } catch { /* ignore */ }
  return [...DEFAULT_COLUMNS];
}

export function saveColumnConfig(columns: ColumnConfig[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(columns));
}
